import clsx from "clsx";

/** Segmented progress: one segment per required step, plus an optional "1/3" label. */
export default function ProgressBar({
  done,
  total,
  showLabel = true,
  className,
}: {
  done: number;
  total: number;
  showLabel?: boolean;
  className?: string;
}) {
  const segments = Math.max(total, 1);
  const filled = Math.min(done, segments);

  return (
    <div className={clsx("flex items-center gap-2", className)}>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={done}
        aria-label={`${done} of ${total} steps done`}
        className="flex flex-1 gap-1">
        {Array.from({ length: segments }, (_, index) => (
          <span
            key={index}
            className={clsx(
              "h-1.5 flex-1 rounded-full transition-colors duration-500",
              index < filled
                ? "bg-blue-600 dark:bg-blue-500"
                : "bg-zinc-200 dark:bg-zinc-700",
            )}
          />
        ))}
      </div>
      {showLabel && (
        <span
          aria-hidden="true"
          className="shrink-0 text-xs font-semibold tabular-nums text-zinc-600 dark:text-zinc-300">
          {done}/{total}
        </span>
      )}
    </div>
  );
}
